var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.question)?_c('div',[_c('basic-question',_vm._b({attrs:{"required":_vm.required,"titleProps":_vm.titleProps,"disabled":""},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'basic-question',_vm.question,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }